export function insertId(url: string, id: number | string) {
  return url.replace('$', String(id));
}



// WEBPACK FOOTER //
// ./src/services/api/insertId.ts